import { Link } from "react-router-dom";
import styles from "../styles/Listings.module.css";

// create a function to create a single dropdown for a unit

const createUnitDropdown = (unit: string, lessons: Lesson[], path: string) => {
    const sortedLessons = [...lessons].sort((a, b) => a.order - b.order);
    return (
        <details open={true} className={styles.listing}>
            <summary>
                <h2>{unit}</h2>
            </summary>
            <ul className={styles.listings}>
                {sortedLessons.map((lesson) => {
                    if (lesson.type === "file") {
                        // if (true) {
                        return (
                            <li>
                                <a href={lesson.url} target="_blank">
                                    {lesson.title}
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            verticalAlign: "middle",
                                            marginLeft: "5px",
                                        }}
                                        className="material-icons"
                                    >
                                        save
                                    </span>
                                </a>
                            </li>
                        );
                    } else if (lesson.type === "lecture") {
                        return (
                            <li>
                                <a href={lesson.url} target="_blank">
                                    {lesson.title}
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            verticalAlign: "middle",
                                            marginLeft: "5px",
                                        }}
                                        className="material-icons"
                                    >
                                        play_circle
                                    </span>
                                </a>
                            </li>
                        );
                    }
                })}
            </ul>
        </details>
    );
};

export default function UnitListings(config: {
    path: string;
    units: UnitList;
    semester?: string;
    semesterSwitcher?: React.ReactNode;
}) {
    const { path, units, semester, semesterSwitcher } = config;

    // Optionally use semester for future features or display
    return (
        <div style={{ position: "relative", minHeight: "40px" }}>
            {semesterSwitcher}
            {units.map((unit) => createUnitDropdown(unit.name, unit.lessons, path))}
        </div>
    );
}
